import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    margin: 36px 61px;

    .title {
        margin-bottom: 36px;
        font-family: 'Montserrat';
        font-size: 22px;
        color: rgba(12, 183, 148, 1);
        text-align: center;
        letter-spacing: 0.04em;
    }

    .landing-content-wrapper {
        border: 1px solid rgba(219, 219, 219, 1);
        cursor: pointer;

        + .landing-content-wrapper { margin-top: 23px; }
    }

    .landing-headlines { display: flex; box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5); }
    .headlines {
        flex-grow: 1;
        padding: 0 14px;
        background-color: rgba(252, 252, 252, 1);
        line-height: 42px;
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }

    .landing-contents { display: flex; padding-top: 16px; padding-bottom: 62px; }
    .contents {
        max-width: 100%;
        padding: 0 14px;
        line-height: 24px;
        font-family: 'Montserrat';
        font-size: 18px;
        font-weight: 300;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.04em;
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Landing/Wrapper.js